import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";
import axios from "axios";

export const sendConsulationsMessageFunc = createAsyncThunk(
  "user/sendConsulationsMessageFunc",
  async ({data , consultationId}) => {
    console.log(data)
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const config  = {
      headers: {
        Authorization: `Bearer ${tokenData}`,
        // "Content-Type": "application/json",
      },
  }
  const request =await axios.post(`${process.env.REACT_APP_VERSEL_API}/api/user/appointments/${consultationId}/send-mail` , data , config);
  console.log(request)
  return request?.data;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const sendConsulationsMessageSlicer = createSlice({
  name: "sendConsulationsMessageSlicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(sendConsulationsMessageFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendConsulationsMessageFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      } else if (action.payload.message === "Email Sent Successfully") {
        state.data = action.payload.data;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(sendConsulationsMessageFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default sendConsulationsMessageSlicer.reducer;
